import { Drawer, Grid } from '@mui/material';
import { useCallback } from 'react';
import { useSearch } from 'src/context/SearchProvider/useSearch';
import { useScrollHandler } from 'src/common/hooks/useScrollHandler';
import LayoutHeader from 'src/components/LayoutHeader/LayoutHeader';
import HeaderBrand from 'src/components/LayoutHeader/HeaderBrand';
import SearchBarInput from 'src/components/LayoutHeader/HeaderSearchBar/variants/SearchBarInput';
import ProductResults from 'src/features/products/presentation/ProductResults';
import EmptySearchTermBox from './EmptySearchTermBox';
import CartLinkButton from 'src/features/cart/presentation/components/CartLinkButton';
import { SearchDrawerProps } from './SearchDrawer.types';
import { useAppUI } from 'src/context/AppUIProvider/useAppUI';
import { FlexColumnContainer, FlexContainer } from 'src/components/styles';

const headerItemColumns = {
  xs: 5,
  sm: 11,
  md: 11,
  xl: 11,
};

const SearchDrawer = ({ open, onClose }: SearchDrawerProps) => {
  const { isMobile } = useAppUI();
  const { searchTerm, clearSearch } = useSearch();
  const handleClose = useCallback(() => {
    clearSearch();
    onClose();
  }, [clearSearch, onClose]);

  const handleScroll = useScrollHandler(isMobile);

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          width: '100%',
          height: '100%',
          bgcolor: 'background.paper',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          paddingTop: { md: 2 },
        },
        onTouchMove: handleScroll,
      }}
    >
      <FlexColumnContainer width="100%" maxWidth="md">
        <LayoutHeader>
          <HeaderBrand
            horizontalAlign="center"
            {...(!isMobile && { columns: headerItemColumns })}
          />
          <SearchBarInput
            autoFocus={!searchTerm}
            onBack={handleClose}
            {...(!isMobile && { columns: headerItemColumns })}
          />
          <Grid item xs={2} sm={1}>
            <FlexContainer
              sx={{ justifyContent: 'flex-end' }}
              pr={{ xs: 1, md: 0 }}
            >
              <CartLinkButton />
            </FlexContainer>
          </Grid>
        </LayoutHeader>
        <FlexColumnContainer justifyContent="flex-start" gap={1} py={2} px={1}>
          {searchTerm ? <ProductResults /> : <EmptySearchTermBox />}
        </FlexColumnContainer>
      </FlexColumnContainer>
    </Drawer>
  );
};

export default SearchDrawer;
